// Event type mapping for different event types
export const eventTypeMap = {
  'fotobox-fuer-abiball-mieten': {
    name: 'Abiball',
    title: 'Fotobox für Abiball in',
    description: 'Mieten Sie eine Fotobox für unvergessliche Abiball-Erinnerungen und stilvolle Abschlussfotos.'
  },
  'fotobox-fuer-abschlussfeier-mieten': {
    name: 'Abschlussfeier',
    title: 'Fotobox für Abschlussfeier in',
    description: 'Mieten Sie eine Fotobox für unvergessliche Abschlussfeier-Erinnerungen und stilvolle Abschlussfotos.'
  },
  'fotobox-fuer-babyshower-mieten': {
    name: 'Babyshower',
    title: 'Fotobox für Babyshower in',
    description: 'Halten Sie die schönsten Momente Ihrer Babyshower mit einer Fotobox fest.'
  },
  'fotobox-fuer-einschulung-mieten': {
    name: 'Einschulung',
    title: 'Fotobox für Einschulung in',
    description: 'Halten Sie die schoensten Momente der Einschulung mit einer Fotobox fest.'
  },
  'fotobox-fuer-jugendweihe-mieten': {
    name: 'Jugendweihe',
    title: 'Fotobox für Jugendweihe in',
    description: 'Halten Sie die schönsten Momente Ihrer Jugendweihe mit einer Fotobox fest.'
  },
  'fotobox-fuer-geburtstag-mieten': {
    name: 'Geburtstag',
    title: 'Fotobox für Geburtstag in',
    description: 'Mieten Sie eine Fotobox für lustige und unvergessliche Geburtstagsbilder.'
  },
  'fotobox-fuer-hochzeit-mieten': {
    name: 'Hochzeit',
    title: 'Fotobox für Hochzeit in',
    description: 'Professionelle Fotobox für traumhafte Hochzeitsfotos und bleibende Erinnerungen.'
  },
  'fotobox-fuer-jubilaeum-mieten': {
    name: 'Jubiläum',
    title: 'Fotobox für Jubiläum in',
    description: 'Feiern Sie Ihr Jubiläum mit einzigartigen Fotobox-Aufnahmen.'
  },
  'fotobox-fuer-karneval-mieten': {
    name: 'Karneval',
    title: 'Fotobox für Karneval in',
    description: 'Bunte Fotobox für ausgelassene Karnevalsfeiern und kreative Kostümbilder.'
  },
  'fotobox-fuer-kindergeburtstag-mieten': {
    name: 'Kindergeburtstag',
    title: 'Fotobox für Kindergeburtstag in',
    description: 'Spaßige Fotobox für fröhliche Kindergeburtstage und bunte Erinnerungen.'
  },
  'fotobox-fuer-kommunion-mieten': {
    name: 'Kommunion',
    title: 'Fotobox für Kommunion in',
    description: 'Festliche Fotobox für schöne Erinnerungen an die Kommunionsfeier.'
  },
  'fotobox-fuer-konfirmation-mieten': {
    name: 'Konfirmation',
    title: 'Fotobox für Konfirmation in',
    description: 'Stilvolle Fotobox für bleibende Konfirmationsmomente.'
  },
  'fotobox-fuer-messe-mieten': {
    name: 'Messe',
    title: 'Fotobox für Messe in',
    description: 'Attraktive Fotobox für Ihren Messestand zur Besucherbindung und Leadgenerierung.'
  },
  'fotobox-fuer-firmenfeier-mieten': {
    name: 'Firmenfeier',
    title: 'Fotobox für Firmenfeier in',
    description: 'Professionelle Fotobox für Firmenfeier oder Teamevents.'
  },
  'fotobox-fuer-sommerfest-mieten': {
    name: 'Sommerfest',
    title: 'Fotobox für Sommerfest in',
    description: 'Fröhliche Fotobox für sonnige Sommerfeste und entspannte Feiern.'
  },
  'fotobox-fuer-polterabend-mieten': {
    name: 'Polterabend',
    title: 'Fotobox für Polterabend in',
    description: 'Ausgelassene Fotobox für lustige Erinnerungen beim Polterabend.'
  },
  'fotobox-fuer-taufe-mieten': {
    name: 'Taufe',
    title: 'Fotobox für Taufe in',
    description: 'Liebevolle Fotobox für die besonderen Momente einer Taufe.'
  },
  'fotobox-fuer-vereinsfeier-mieten': {
    name: 'Vereinsfeier',
    title: 'Fotobox für Vereinsfeier in',
    description: 'Die passende Fotobox für Vereinsfeste, Jubiläen und gemeinsame Erinnerungen.'
  },
  'fotobox-fuer-verlobung-mieten': {
    name: 'Verlobung',
    title: 'Fotobox für Verlobung in',
    description: 'Romantische Fotobox für Verlobungsfeier und besondere Momente.'
  },
  'fotobox-fuer-weihnachtsfeier-mieten': {
    name: 'Weihnachtsfeier',
    title: 'Fotobox für Weihnachtsfeier in',
    description: 'Festliche Fotobox für weihnachtliche Erinnerungen und Spaß im Team.'
  }
};

export default eventTypeMap
